import { Component, OnDestroy } from '@angular/core';

import { ShComplexMapReadonlyFieldComponent } from '../complex-map-readonly-field/complex-map-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-map-readonly-field',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    templateUrl: '../complex-map-readonly-field/complex-map-readonly-field.component.html'
})
export class ShMapReadonlyFieldComponent extends ShComplexMapReadonlyFieldComponent implements OnDestroy {
    public static override readonly IS_COMPLEX: boolean = true;
}
